import { Button, Tooltip } from 'antd'
import React from 'react'
import { SyncOutlined } from '@ant-design/icons'

const buttonType = {
  primary: 'bg-button-primary text-white border-none',
  secondary: 'bg-white text-base-primary border-[#BE123C] hover:border-[#BE123C]',
  plain: 'bg-white hover:bg-surface-primary-3 text-primary hover:text-primary border-lighter',
  danger: 'bg-button-danger text-white border-none',
  success: 'text-text-success bg-surface-success-light border-[#3c8015]',
  'plain-danger': 'bg-white text-button-danger border-button-danger text-button-danger',
  'primary-light': 'bg-[#FFFFFF29] text-white border-none'
}

const buttonSize = {
  xs: '',
  sm: '!py-1.5 !px-3 text-sm',
  base: '!py-2 md:!py-2 !px-5 md:!px-6 text-sm md:text-base',
  md: '',
  lg: ''
}

function CustomButton({
  type = 'primary',
  size = 'base',
  children,
  onClick,
  isLoading = false,
  disabled,
  className = '',
  htmlType = 'button',
  icon = undefined,
  hoverMessage = ''
}) {
  const isDisabled = isLoading || disabled

  const button = (
      <Button 
         htmlType={htmlType} 
         onClick={isLoading || disabled ? null : onClick} 
         disabled={disabled} 
         icon={icon} 
         loading={isLoading && { icon: <SyncOutlined spin /> }} 
         className={`flex gap-2 ${isDisabled && hoverMessage ? 'w-full' : ''} ${buttonSize[size]} font-medium md:text-base h-fit items-center justify-center rounded-lg border border-solid disabled:bg-lighter disabled:text-hint ${buttonType[type]} ${className}`}> 
         {children} 
      </Button>
  )

  if (isDisabled && hoverMessage) {
    return (
      <Tooltip 
         title={hoverMessage}>
        <span className="block w-full">
          {button}
        </span>
      </Tooltip>
    )
  }

  return button
}

export default CustomButton